import { Supplier } from "@/v2/types";
import axios from "axios";

// const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export default async function LinkValidation(id: string): Promise<Supplier> {
    try {
        const res = await axios.get(
            `https://api.ems.lofritex.co.in/api/v1/vendors/token-check/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${id}`,
                    "Content-Type": "application/json",
                },
            },
        );
        return res.data;
    } catch (error) {
        console.error("Error validating link:", error);
        throw error;
    }
}
